import { io, Socket } from 'socket.io-client';

function socketServerUrl(): string {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}

export function connectMembershipAdminSocket(token: string): Socket {
  return io(socketServerUrl(), {
    auth: { token },
    transports: ['websocket', 'polling'],
  });
}

export async function registerMembershipAdminSocket(
  socket: Socket,
  token: string
): Promise<boolean> {
  return new Promise((resolve) => {
    socket.emit('registerMasterAdmin', { token }, (ack: { success?: boolean }) => {
      resolve(Boolean(ack?.success));
    });
    setTimeout(() => resolve(false), 5000);
  });
}
